export default {	
	getSaveRows_({ resultList }) {
		return resultList.filter(item => item.tableState === 'U' || item.tableState ==="I");
	},
	getColumns_(state, getters, rootState, rootGetters) {
		return [
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001154'), //부서코드
				prop: 'deptCd',
				minWidth: '100px',
				sortable: true,
				form: {
					type: 'input'
				}
			},
			{
				label: rootGetters['commonStore/getMessage_']('QWCC001153'), //부서명
				prop: 'deptNm',
				minWidth: '150px',
				sortable: true,
				form: {
					type: 'input'
				}
			}			
		];
	}
};
